import React from 'react'
import { FiArrowUpRight } from 'react-icons/fi'
import HistoryPage from './dashboardShell/HistoryPage'

const usd = (value) => `$${Number(value || 0).toLocaleString()} USD`

// Withdrawal history (/withdrawlogs)
const WithdrawalLogs = ({ route }) => (
  <HistoryPage
    route={route}
    topbarTitle="Withdrawal History"
    hero={{
      icon: <FiArrowUpRight />,
      eyebrow: 'Withdrawals',
      title: 'Withdrawal history',
      description: 'Every withdrawal you have made, with the balance left after each one.',
    }}
    heroAside={(user) => (
      <div className="ud-hero-figure">
        <span>Total withdrawn</span>
        <strong>${Number(user.totalwithdraw || 0).toLocaleString()}</strong>
      </div>
    )}
    sectionTitle="All withdrawals"
    getRows={(user) => user.withdraw}
    columns={[
      { label: 'Date', render: (row) => row.date },
      { label: 'Amount', render: (row) => usd(row.amount) },
      { label: 'ID', render: (row) => row.id },
      { label: 'Balance', render: (row) => usd(row.balance) },
      { label: 'Status', render: () => <span className="ud-badge ud-badge-profit">Approved</span> },
    ]}
    emptyText="You haven't made any withdrawals yet."
    emptyAction={{ to: '/withdraw', label: 'Request a withdrawal' }}
  />
)

export default WithdrawalLogs
